module.exports = __webpack_public_path__ + "img/postback-step-1.en.87b46e6d.jpg";